import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["surface"]
  static values = { url: String }

  changeFont(event) {
    this.surfaceTarget.dataset.writingFont = event.currentTarget.value
    this.persist({ writing_font: event.currentTarget.value })
  }

  changeSize(event) {
    this.surfaceTarget.dataset.writingFontSize = event.currentTarget.value
    this.persist({ writing_font_size: event.currentTarget.value })
  }

  async persist(preferences) {
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
        "Accept": "application/json"
      },
      body: JSON.stringify({ appearance: preferences }),
      credentials: "same-origin"
    })

    if (!response.ok) window.location.reload()
  }
}
